<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="key" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="key" />

    <tabbar v-if="$route.meta.showTab" />
  </div>
</template>

<script>
import Tabbar from './components/Tabbar'

export default {
  name: 'App',
  components: {
    Tabbar
  },
  computed: {
    key() {
      return this.$route.fullPath
    }
  }
}
</script>

<style lang="scss">
html,
body {
  overflow-x: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
}

body {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

#app {
  height: 100%;
  overflow-y: auto;
  background: #fff;
}
</style>
